import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import avatar from '../assets/images/profil/avatar-portfolio.jpg';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} className="zoom" alt="thumbnail" width="100%"/>
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/nagiraud" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/nathangiraud" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Nathan Giraud</h1>
          <p>Développeur</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/nagiraud" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/nathangiraud" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;